/* eslint-disable turbo/no-undeclared-env-vars */
import packageJson from "../../package.json";

// ----------------------------------------------------------------------

export interface ConfigValue {
	site: {
		name: string;
		apiUrl: string;
		version: string;
		uploadPDFBucket: string;
		uploadVideoBucket: string;
		maxUploadFileSizeBytes: number;
	};
}

// ----------------------------------------------------------------------

export const CONFIG: ConfigValue = {
	site: {
		name: "OnAir - Host",
		apiUrl: process.env.NEXT_PUBLIC_HOST_PATH ?? "/host",
		version: packageJson.version,
		uploadPDFBucket: process.env.NEXT_PUBLIC_PDF_BUCKET || "",
		uploadVideoBucket: process.env.NEXT_PUBLIC_VIDEO_BUCKET || "",
		maxUploadFileSizeBytes: 4 * 1024 * 1024 * 1024, // 4GB
	},
};
